<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span>条件筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="优惠券名称" prop="name">
              <el-input
                v-model="queryForm.name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="编码" prop="code">
              <el-input
                v-model="queryForm.code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="产品名称" prop="product_ids">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="openProductForm.productIds"
                ref="openProductRef"
                multiple
              >
            <el-option
              v-for="item in dict_openProductId"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="使用状态" prop="status">
              <el-select
                placeholder="请选择"
                v-model="queryForm.status"
                clearable
              >
                <el-option
                  v-for="item in dict_used"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="会员专享" prop="vipBuy">
              <el-select
                placeholder="请选择"
                v-model="queryForm.vipBuy"
                clearable
              >
                <el-option
                  v-for="item in dict_vipBuy"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="开始时间" prop="beginTime">
              <el-date-picker
                type="datetime"
                placeholder="选择日期/时间"
                :editable="false"
                :picker-options="pickerOptions"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="receiptForm.beginTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="选择日期/时间"
                :editable="false"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="receiptForm.endTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="getDataList"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 优惠券列表 -->
    <el-card class="list_card" style="margin-top: 20px">
      <el-row class="title_row">
        <el-col :span="12">
          <div class="list_title">优惠券列表</div>
        </el-col>
        <el-col :span="12">
          <div style="text-align: right">
            <el-button type="primary" @click="createCode">生成优惠券</el-button>
          </div>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="编码" prop="code"></el-table-column>
        <el-table-column label="开始时间" prop="beginTime"></el-table-column>
        <el-table-column label="结束时间" prop="endTime"></el-table-column>
        <el-table-column label="抵扣金额" prop="price"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status === false" size="mini"
              >未启用</el-tag
            >
            <el-tag type="success" v-else size="mini">已启用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="剩余数量" prop="surplusNum"></el-table-column>
        <el-table-column label="已使用数量" prop="useNum"></el-table-column>
        <el-table-column label="适用人群">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.vipBuy === false" size="mini"
              >所有人群</el-tag
            >
            <el-tag type="warning" v-else size="mini">VIP用户</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showChangeStateDialog(scope.row)"
              >修改状态</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="showCouponDetailClicked(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 修改优惠券使用状态Dialog -->
    <el-dialog
      title="修改使用状态"
      :visible.sync="changeUsedDialogVisible"
      width="30%"
    >
      <el-form
        :model="changeSatetForm"
        ref="changeSatetFormRef"
        :rules="changeSatetFormRules"
        label-width="140px"
      >
        <el-form-item label="使用状态" prop="statusIn">
          <el-select
            placeholder="请选择"
            v-model="changeSatetForm.statusIn"
            clearable
          >
            <el-option
              v-for="item in dict_used"
              :key="item.dictCode"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeUsedDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeUsed()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增优惠券Dialog -->
    <el-dialog
      title="新增优惠券"
      :visible.sync="addCouponDialogVisible"
      @close="addCouponDialogClose()"
      width="50%"
    >
      <el-form
        :model="addCouponForm"
        ref="addCouponFormRef"
        :rules="addCouponFormRules"
        label-width="100px"
      >
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="addCouponForm.name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="code">
              <el-input
                v-model="addCouponForm.code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="价格" prop="price">
              <el-input
                v-model="addCouponForm.price"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="surplusNum">
              <el-input
                v-model="addCouponForm.surplusNum"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="beginTime">
              <el-date-picker
                type="datetime"
                placeholder="选择日期/时间"
                :editable="false"
                :picker-options="pickerOptions"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="addCouponForm.beginTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                type="datetime"
                :picker-options="pickerOptions"
                placeholder="选择日期/时间"
                :editable="false"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="addCouponForm.endTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="12">
            <el-form-item label="使用状态" prop="statusIn">
              <el-select
                style="width:100%"
                placeholder="请选择"
                v-model="addCouponForm.statusIn"
                clearable
              >
                <el-option
                  v-for="item in dict_used"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员专享" prop="vipBuy">
              <el-select
                placeholder="请选择"
                v-model="addCouponForm.vipBuy"
                clearable
              >
                <el-option
                  v-for="item in dict_vipBuy"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="20">
            <el-form-item label="产品名称" prop="productIds">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addCouponForm.productIds"
                ref="openProductRef"
                multiple
              >
                <el-option
                  v-for="item in codeTypeList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCouponDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCouponClicked()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCouponList, updateCouponStatus, couponInsert, getFlagListData, queryDistrictPage } from '@/http/api'
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      addCouponForm: {
        productIds: []
      },
      addCouponFormRules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        code: [{ required: true, message: '请输入', trigger: 'blur' }],
        statusIn: [{ required: true, message: '请选择', trigger: 'change' }],
        price: [{ required: true, message: '请输入', trigger: 'blur' }],
        beginTime: [{ required: true, message: '请选择', trigger: 'change' }],
        vipBuy: [{ required: true, message: '请选择', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择', trigger: 'change' }],
        surplusNum: [{ required: true, message: '请输入', trigger: 'blur' }],
        productIds: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      changeSatetFormRules: {
        statusIn: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      changeSatetForm: {
        statusIn: null
      },
      addCouponDialogVisible: false,
      changeUsedDialogVisible: false,
      queryForm: {
        name: '',
        vipBuy: null,
        status: null,
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      dict_type: [
        {
          dictCode: 1,
          dictLabel: '本组别词库',
          dictValue: 0
        },
        {
          dictCode: 2,
          dictLabel: '个人赛初赛',
          dictValue: 51
        },
        {
          dictCode: 3,
          dictLabel: '个人赛复赛',
          dictValue: 58
        }
      ],
      dict_vipBuy: [
        {
          dictCode: 1,
          dictLabel: '是',
          dictValue: true
        },
        {
          dictCode: 0,
          dictLabel: '否',
          dictValue: false
        }
      ],
      dict_used: [
        {
          dictCode: 0,
          dictLabel: '未启用',
          dictValue: 0
        },
        {
          dictCode: 1,
          dictLabel: '已启用',
          dictValue: 1
        }
      ],
      dict_district: [],
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      dataList: []
    }
  },
  created () {
    this.getFlagList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getDistictData () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取产品标识列表
    getFlagList () {
      getFlagListData({}).then((res) => {
        console.log('getFlagListData', res)
        this.codeTypeList = res.data
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取优惠券列表
    getDataList () {
      getCouponList(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 显示修改状态弹窗
    showChangeStateDialog (rowData) {
      this.changeSatetForm.id = rowData.id
      this.changeSatetForm.statusIn = rowData.status === true ? 1 : 0
      this.changeUsedDialogVisible = true
    },
    // 提交状态修改
    changeUsed () {
      this.changeSatetForm.status = this.changeSatetForm.statusIn !== 0
      updateCouponStatus(this.changeSatetForm).then((res) => {
        this.$message.success('修改成功')
        this.changeUsedDialogVisible = false
        this.getDataList()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    async addCouponClicked () {
      this.$refs.addCouponFormRef.validate(async valid => {
        if (!valid) return
        this.addCouponForm.status = this.addCouponForm.statusIn !== 0
        couponInsert(this.addCouponForm).then((res) => {
          this.$message.success('添加成功')
          this.addCouponDialogVisible = false
          this.reset()
        }).catch((err) => {
          console.log('err', err)
        })
      })
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    addCouponDialogClose () {
      // this.addCouponForm.productIds = []
      this.$refs.addCouponFormRef.resetFields()
    },
    // 查看优惠券详情
    showCouponDetailClicked (rowData) {
      this.$router.push(
        {
          path: '/product_Management/productcoupon_management_detail',
          query: {
            couponId: rowData.id
          }
        }
      )
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    createCode () {
      this.addCouponDialogVisible = true
    }
  }
}
</script>

<style>
</style>
